<kilowant-header [isBuyer]="true" title="Accept Offer"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain backgroundImage">
  <div class="progress-tabs mt-20">
    <div class="info mb-20">Please complete the following steps<br/>to accept the offer.</div>
    <span [class]="(step==1)?'current':''" [class]="(disableStep1)?'disabled':''">1</span>
    <span [class]="(step==2)?'current':''">2</span>
    <span [class]="(step==3)?'current':''">3</span>
  </div>
  @if (offer!=null) {
    <div class="form buyer">
      <!-- Step 1 -->
      @if (step == 1) {
        <div class="card">
          <div class="left-margin"><span class="step-title">1</span></div>
          <div class="body">
            <h2>Select Utility Accounts</h2>
            <div class="right-margin-icon info-icon after-h2 link" (click)="iIconPopup('<h2>More Than One Account?</h2>Offers are valid for one or many accounts which contain the same utility, load zone, and rate class. If you have additional accounts meeting these characteristics, you can add them via the Add Accounts link in the main menu. You will then need to restart the offer acceptance process to have them included in this transaction.');"></div>
            <div>
                @for (gData of accountsSelector; track gData; let pg = $index) {
                <div [class]="(pg>0)?'mt-20':''" class="group">{{gData.groupName}}</div>
                @for (aData of gData.accountData; track aData; let p = $index) {
                <div class="checkbox-list"><label><input type="checkbox" [checked]="ifItemSelected(aData.id)" (change)="selectItem(p)"> {{aData.accountName}}</label></div>
                }
                }
            </div>
            @if (this.errorY().showError()) {
              <div class="error-block">{{this.errorY().error}}</div>
            }
          </div>
        </div>
      }
      @if (step == 1) {
        <div class="block-buttons full-width under-card">
          <button type="button" (click)="cancel()">Cancel</button>
          <button type="button" (click)="finishStep1()">Continue</button>
        </div>
      }
      <!-- Step 2 -->
      @if (step == 2) {
        <div class="card">
          <div class="left-margin"><span class="step-title">2</span></div>
          <div class="body">
            <h2>Confirm Utility Account Details</h2>
            <div class="right-margin-icon info-icon after-h2 link" (click)="iIconPopup('<h2>Account Data Accurate?</h2>If the utility, load zone or rate class listed on your utility bill are different from what\'s listed below you will need to go to the main menu, select Accounts, delete the account, create a new account and restart the offer selection process as offers are based on your account profile.');"></div>
            @if (selectedAccounts.length>1) {
              <div class="progress-tabs smaller mb-10">
                @for (account of selectedAccounts; track account; let p = $index) {
                  <span class="link" [class]="(currentAccountStep==(p+1))?' current':''" (click)="changeStep(p+1)">{{p+1}}</span>
                }
              </div>
            }
            @for (account of selectedAccounts; track account; let p = $index) {
              @if (currentAccountStep==(p+1)) {
                <div>
                  <kilowant-account-edit [(account)]="selectedAccounts[p]!" (changed)="changeCurrentAccountInfo()" [isFromOffer]="true"
                  [callUpdate]="callUpdate" [callCancel]="callCancel" (cancelled)="editFinish()" (finished)="editFinish()"></kilowant-account-edit>
                </div>
              }
            }
            @if (this.errorY().showError()) {
              <div class="error-block">{{this.errorY().error}}</div>
            }
          </div>
        </div>
      }
      @if (step == 2) {
        <div class="block-buttons full-width under-card">
          <button type="button" (click)="cancel()">Cancel</button>
          <button type="button" (click)="updateAccount()">Continue</button>
        </div>
      }
      <!-- Step 2 -->
      @if (step == 3) {
        <div class="card">
          <div class="left-margin"><span class="step-title">3</span></div>
          <div class="body">
            @if (accounts!=null) {
              <div>
                <h2>Review Terms &amp; Conditions</h2>
                @if (account!=null) {
                  <div>
                    <div class="title">
                      <div>
                        <div class="element-detail">
                          @if (offer.sellerContract.termsDocument==null) {
                            <div class="account-info-block">
                              <p class="card-block-background">TRANSACTION SUMMARY</p>
                              <div class="visible">
                                @for (rec of formatSelectedAccounts(); track rec; let p = $index) {
                                  <p class="accountInfoBorder">{{rec.key}}</p>
                                  @for (account of rec.value; track account; let r = $index) {
                                    <div class="subUniqueTitle d-flex">
                                      <div>{{(r+1)}}.</div>
                                      <div class="auto long-text-cut">{{accountIdent(account)}}</div>
                                    </div>
                                  }
                                }
                                <div>
                                  <p class="accountInfoBorder">Supplier Name</p>
                                  <p class="subUniqueTitle">{{offer.company.name}}</p>
                                  <p class="accountInfoBorder">Price</p>
                                  <p class="subUniqueTitle">{{offer.priceForBuyer() | currency:'USD':'symbol':'1.5-5'}}/kWh</p>
                                  <p class="accountInfoBorder">Service Start</p>
                                  <p class="subUniqueTitle">1st meter read on or after {{offer.termFrom | date:'shortDate'}}</p>
                                  <p class="accountInfoBorder">Service End</p>
                                  <p class="subUniqueTitle"> 1st meter read on or after {{getTermTo(offer.termFrom, offer.termPeriod) | date:'shortDate'}}</p>
                                  <p class="accountInfoBorder">Term</p>
                                  <p class="subUniqueTitle grey-text">{{offer.termPeriod}} months</p>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <div><br>BY CLICKING <strong> ACCEPT OFFER </strong> YOU CERTIFY, ACKNOWLEDGE AND AGREE
                        THAT: <br><br>
                        <div class="p-l-r">
                          <p>
                            (1) YOU HAVE READ, UNDERSTAND AND AGREE TO BE BOUND BY THE SELLER CONTRACT LINKED BELOW ("SALES AGREEMENT") FOR THE UTILITY ACCOUNTS, PRICE, AND SERVICE TERM REFERENCED IN THE ABOVE TRANSACTION SUMMARY, and
                            <br><br>(2) THE SALES AGREEMENT CONSTITUTES A LEGAL
                            AGREEMENT ENTERED INTO BETWEEN YOU AND THE STATED SALES ENTITY SERVING AS A COUNTERPARTY TO SUCH
                            SALES AGREEMENT.
                          </p>
                          <p class="font13">
                            You further certify to and agree that you or your representative or agent entering into the Sales
                            Agreement
                            on your behalf is of the legal age of majority and has the right and authority to enter into the
                            Sales agreement on your own behalf, and that if your representative or agent is entering into said
                            Sales Agreement on
                            behalf of you as a company, organization, educational institution, or agency, instrumentality, or
                            department of the government, that such representative or agent has the right and authority to
                            legally bind you to all
                            the terms and obligations of the Sales Agreement.
                          </p>
                        </div>
                      </div>
                      @if (offer.sellerContract.termsDocument==null) {
                        <div class="account-info-block">
                          <p class="card-block-background" [class]="(showSellerContractTerms)?'':'view-closed'">SALES AGREEMENT
                            <a [class]="(showSellerContractTerms)?'collapse':'open'" (click)="showSellerContractTerms=(showSellerContractTerms)?false:true;"></a>
                          </p>
                          @if (showSellerContractTerms) {
                            <div [innerHTML]="offer.sellerContract.terms" class="visible font13 p-5"></div>
                          }
                        </div>
                      }
                      @if (offer.sellerContract.termsDocument!=null) {
                        <div class="account-info-block">
                          <p class="card-block-background view-closed">
                            <a class="link" (click)="sendTerms()">SALES AGREEMENT <span class="pdf-icon"></span></a>
                          </p>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (step==3) {
      <div class="block-buttons full-width under-card">
        <button type="button" (click)="cancel()">CANCEL</button>
        <button appOneClick type="button" class="green-button" (oneClick)="acceptSellOffer()">ACCEPT OFFER</button>
      </div>
    }
  </div>
}